import type { ReactNode } from 'react';
import { SwarmLockup, SupportedByWarriorLab, SwarmMark } from './SwarmMark';

/**
 * Public auth shell — a split title page, not a floating card. The left panel
 * carries the swarm identity on the deep shell; WarriorLab appears as the
 * supporting credit. The form sits on plain white.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex h-full">
      {/* Brand panel */}
      <div className="relative hidden w-[44%] max-w-[560px] flex-col justify-between overflow-hidden bg-shell p-10 lg:flex">
        <SwarmMark className="pointer-events-none absolute -bottom-28 -left-20 w-[440px] text-[#2dd4bf] opacity-[0.08]" />
        <SwarmLockup tone="dark" size="lg" className="relative" />
        <div className="relative mb-16">
          <p className="kicker !text-shell-muted">Orchestration platform</p>
          <p className="mt-3 max-w-xs font-display text-[28px] font-medium leading-snug text-white">
            Agents, knowledge and delivery in one hive.
          </p>
        </div>
        <div className="relative">
          <SupportedByWarriorLab tone="dark" />
        </div>
      </div>

      {/* Form panel */}
      <div className="flex flex-1 items-center justify-center bg-surface px-6">
        <div className="w-full max-w-sm">
          <SwarmLockup tone="light" className="mb-10 lg:hidden" />
          <p className="kicker mb-2">Sign in</p>
          <h1 className="text-[26px] font-semibold leading-tight">{title}</h1>
          <div className="grad-bar mt-3 h-[3px] w-14 rounded-full" aria-hidden />
          {subtitle && <p className="mt-3 text-sm text-fg-muted">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <p className="mt-8 text-xs leading-relaxed text-fg-subtle">{footer}</p>}
        </div>
      </div>
    </div>
  );
}
